import { useState } from "react";
import { ArrowUpRight, Send, CheckCircle2, Phone, Mail } from "lucide-react";
import { submitContact } from "../../lib/api";
import { toast } from "sonner";
import "./ContactSection.css";
import mailIcon from "../ui/mail.svg";
import phoneIcon from "../ui/phone.svg";
import whappIcon from "../ui/WHATSAPP copy.svg";

const INTERESTS = [
    "DEFENCE TRAINING",
    "IMMERSIVE EXPERIENCE",
    "INTELLITRACK ",
    "INTERACTIVE EXHIBIT", "Indigenous Hardware", "DEEP TECH", "VIRTUAL PRODUCTION",
    "Other",
];


export const ContactSection = ({ defaultInterest = "" }) => {

    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        company: "",
        interest: defaultInterest,
        message: "",
    });
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);

    const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.email || !form.message) {
            toast.error("Please fill in your name, email and a brief message.");
            return;
        }
        try {
            submitting || setSubmitting(true);
            await submitContact(form);
            setSuccess(true);
            toast.success("Brief received. We will respond within 24 hours.");
            setForm({
                name: "",
                email: "",
                phone: "",
                company: "",
                interest: defaultInterest,
                message: "",
            });
        } catch (err) {
            console.error(err);
            toast.error("Submission failed. Please email sales@dbproductions.in directly.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="contact-section py-5 py-md-10 border-top"
        >
            <div className="container-db">
                <div className="row g-5">
                    {/* Left — copy */}
                    <div className="col-12 col-lg-5">
                        <div className="font-mono-tech section-eyebrow mb-4 fade-in-up fs-5">
                            ⟶ Initiate Contact
                        </div>
                        <h4 className="font-heading contact-heading" style={{ fontSize: '4rem' }}>
                            Let's Talk
                        </h4>
                        <div className="contact-addresses mt-4 mb-5 d-flex flex-column gap-4" style={{ fontFamily: 'Inter' }}>
                            <div>
                                <h5 className="text-primary-custom mb-2" style={{ fontSize: '16px', fontWeight: '400' }}>India : </h5>

                                <p className="mb-0" style={{ fontSize: '15px', color: '#FFFF' }}>
                                    #364, Paneer Nagar Main Road,<br />
                                    Auravilla, 2nd Floor, Mogappair East,<br />
                                    Chennai - 600 037
                                </p>
                                <br></br>

                                <p className="mb-0 " style={{ fontSize: '15px', color: '#FFFF' }}>
                                    #3A/15, 2nd Floor, Mogappair Industrial Estate,<br />
                                    Mogappair East,<br />
                                    Chennai - 600 037
                                </p>
                            </div>


                            <div>
                                <h5 className="text-primary-custom mb-2" style={{ fontSize: '16px', fontWeight: '400' }}>Singapore :</h5>
                                <p className="mb-0" style={{ fontSize: '15px', color: '#FFFF' }}>
                                    #158 Kallang Way, #02-511,<br />
                                    Performance Building,<br />
                                    Singapore - 349245
                                </p>
                            </div>
                        </div>

                        <div className="mt-4 d-flex flex-column gap-3 contact-links">
                            <a
                                href="tel:+919363035021"
                                className="text-white text-decoration-none contact-info-link d-flex align-items-center gap-3 font-mono-tech"
                                data-testid="contact-direct-phone"
                            >
                                <div className="contact-icon-wrapper">
                                    <img src={phoneIcon}></img>
                                </div>
                                +91 9445699155
                            </a>
                            <a
                                href="https://mail.google.com/mail/?view=cm&fs=1&to=sales@dbproductions.in"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-white text-decoration-none contact-info-link d-flex align-items-center gap-3 font-mono-tech"
                                data-testid="contact-direct-email"
                            >
                                <div className="contact-icon-wrapper">
                                    <img src={mailIcon}></img>
                                </div>
                                sales@dbproductions.in
                            </a>
                            <a
                                href="https://wa.me/919363035021"
                                target="_blank"
                                rel="noreferrer"
                                data-testid="contact-whatsapp"
                                className="text-white text-decoration-none contact-info-link d-flex align-items-center gap-3 font-mono-tech"
                            >
                                <div className="contact-icon-wrapper">
                                    <img src={whappIcon}></img>
                                </div>
                                +91 9445699155
                            </a>
                        </div>
                    </div>

                    {/* Right — form */}
                    <div className="col-12 col-lg-7">
                        {success ? (
                            <div
                                data-testid="contact-success"
                                className="success-box p-5 text-center"
                            >
                                <CheckCircle2 size={48} className="text-primary-custom mx-auto mb-4" />
                                <h3 className="font-heading success-title mb-3">
                                    Brief Received
                                </h3>
                                <p className="success-desc max-w-md mx-auto mb-4">
                                    Our mission desk has logged your enquiry. Expect a response within
                                    24 hours.
                                </p>
                                <button
                                    type="button"
                                    onClick={() => setSuccess(false)}
                                    data-testid="contact-send-another"
                                    className="btn-send-another font-mono-tech"
                                >
                                    Send another brief
                                </button>
                            </div>
                        ) : (
                            <form
                                onSubmit={onSubmit}
                                data-testid="contact-form"
                                className="form-box p-4 p-md-5 d-flex flex-column gap-4"
                            >
                                <div className="row g-4 text-light" style={{ fontFamily: 'Inter' }}>
                                    <div className="col-12 col-md-6 ">
                                        <Field
                                            label="Name"
                                            required
                                            value={form.name}
                                            onChange={update("name")}
                                            testid="contact-input-name"
                                            placeholder="Enter Your Full Name"
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <Field
                                            label="Email"
                                            type="email"
                                            required
                                            value={form.email}
                                            onChange={update("email")}
                                            testid="contact-input-email"
                                            placeholder="you@company.in"
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <Field
                                            label="Phone"
                                            value={form.phone}
                                            onChange={update("phone")}
                                            testid="contact-input-phone"
                                            placeholder="Enter Phone Number"
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <Field
                                            label="Organisation"
                                            value={form.company}
                                            onChange={update("company")}
                                            testid="contact-input-company"
                                            placeholder="Company / Unit"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <Label>Interest Area</Label>
                                    <div className="d-flex flex-wrap gap-2 mt-3">
                                        {INTERESTS.map((it) => (
                                            <button
                                                key={it}
                                                type="button"
                                                onClick={() => setForm({ ...form, interest: it })}
                                                data-testid={`contact-interest-${it.replace(/\s+/g, "-").toLowerCase()}`}
                                                className={`interest-btn font-mono-tech ${form.interest === it ? "active" : ""
                                                    }`}
                                            >
                                                {it}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <div className="d-flex flex-column gap-2">
                                    <Label htmlFor="message">Brief *</Label>
                                    <textarea
                                        id="message"
                                        required
                                        rows={5}
                                        value={form.message}
                                        onChange={update("message")}
                                        data-testid="contact-input-message"
                                        placeholder="Tell us about the mission, the event, the audience, the deadline…"
                                        className="form-textarea"
                                    />
                                </div>

                                <button
                                    type="submit"
                                    disabled={submitting}
                                    data-testid="contact-submit-button"
                                    className="btn-submit font-mono-tech align-self-start"
                                >
                                    {submitting ? "Transmitting…" : "Submit"}
                                    <Send size={16} strokeWidth={2.5} className="ms-2" />
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

const Label = ({ children, htmlFor }) => (
    <label
        htmlFor={htmlFor}
        className="font-mono-tech input-label"
    >
        {children}
    </label>
);

const Field = ({ label, value, onChange, type = "text", placeholder, testid, required }) => (

    <div className="d-flex flex-column gap-2">
        <Label htmlFor={testid}>{label}{required ? " *" : ""}</Label>
        <input
            id={testid}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
            data-testid={testid}
            className="form-input"
        />
    </div>
);

export default ContactSection;
